import './modules/navigation.js'
import AOS from 'aos'

window.addEventListener('DOMContentLoaded', () => {
	AOS.init({
		duration: 1000,
		once: true,
		offset: 30,
	})

	setTimeout(() => {
		AOS.refresh()
	}, 100)
})
